import { useQuery } from '@tanstack/react-query';
import api from '../../http';

export interface OnlineUsersByState {
	state: string;
	name: string;
	onlineUsers: number;
}

export interface UserOnlineByRegionResponse {
	states: OnlineUsersByState[];
}

export const useGetUserOnlineByRegion = (states?: string | string[]) => {
	return useQuery({
		queryKey: ['user-online-by-states', states],
		refetchInterval: 15_000,
		refetchIntervalInBackground: false,
		queryFn: async () => {
			const params = new URLSearchParams();
			const values = typeof states === 'string' ? [states] : (states ?? []);

			for (const value of values) {
				if (value.trim()) params.append('states', value);
			}

			const { data } = await api.get<UserOnlineByRegionResponse>('/user/online/countByStates', {
				params,
			});
			return data;
		},
	});
};
